import { Recurso } from "lib.common/dist/CleanArch";

export abstract class UseCaseRecursoAsync<I, O> {
   abstract call(input: I): Promise<Recurso<O>>;
}
